var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 32,
    viewBox: "0 0 76 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8.80423,
    fill: "#1B1B1B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2494 11.2827C19.4724 12.3395 18.2947 14.7813 17.8945 18.2393C17.6997 19.923 17.305 21.1499 16.5728 22.3479C15.7724 23.6574 14.5559 24.7205 13.3082 25.2007C13.0235 25.3102 12.8195 25.4272 12.855 25.4605C12.9505 25.5499 14.8888 25.628 15.5876 25.5706C16.4314 25.5011 17.9455 25.0695 18.5443 24.7276C19.904 23.9511 20.9867 22.5926 21.5188 20.9948C21.8901 19.88 22.0187 19.2068 22.1523 17.6782C22.3204 15.7557 22.7408 14.259 23.3082 13.1505C23.9027 11.9892 25.0935 11.3292 26.3126 10.8645C26.5929 10.7576 26.7835 10.6817 26.7807 10.6714C26.7727 10.6417 25.0456 10.6714 24.0441 10.6714C23.1984 10.6211 21.8755 10.9105 21.2494 11.2827Z",
    fill: "url(#paint0_linear_1846_32440)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7157 13.2447C16.7168 13.4873 16.7096 13.6807 16.7025 13.8771C16.6969 14.0334 16.5272 14.1262 16.3917 14.0481C16.3116 14.002 16.2397 13.9427 16.184 13.8689C16.0696 13.7172 15.8659 13.4219 15.7239 13.0737C15.6695 12.9401 15.6174 12.7999 15.5679 12.6575C15.1519 11.4589 14.9357 10.1985 14.8457 8.93292C14.8223 8.60419 14.809 8.27605 14.8156 7.98887C14.8401 6.9209 14.8147 6.28479 15.1662 5.276L15.1695 5.26636C15.3111 4.86003 15.3424 4.77026 15.4561 4.464C15.6068 4.10585 15.9331 4.2767 15.9546 4.49053C15.9819 4.76055 16.0048 4.98179 16.0158 5.07581C16.2946 7.45115 16.2737 8.80139 16.5617 11.1756C16.6604 11.989 16.712 12.4344 16.7157 13.2447Z",
    fill: "url(#paint1_linear_1846_32440)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0718 13.342C14.1245 13.5398 14.1599 13.6992 14.1961 13.8611C14.2248 13.9899 14.1061 14.1019 13.9788 14.0671C13.9036 14.0465 13.8323 14.0135 13.771 13.9651C13.6452 13.8657 13.4159 13.6681 13.2256 13.4141C13.1527 13.3167 13.0802 13.2134 13.0094 13.1076C12.4139 12.2179 11.9683 11.2351 11.6247 10.2211C11.5355 9.95773 11.4545 9.69268 11.3986 9.45682C11.1906 8.5797 11.0341 8.0658 11.1057 7.16721L11.1063 7.15861C11.1352 6.79667 11.1415 6.71671 11.169 6.4424C11.2156 6.11783 11.5184 6.18767 11.5817 6.35763C11.6616 6.57226 11.7275 6.74799 11.7566 6.82239C12.4913 8.70209 12.7624 9.80889 13.5044 11.6857C13.7586 12.3287 13.8958 12.6813 14.0718 13.342Z",
    fill: "url(#paint2_linear_1846_32440)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2229 14.4304C12.3187 14.5581 12.3898 14.6642 12.4622 14.7719C12.5198 14.8576 12.4468 14.9985 12.329 15.0305C12.2593 15.0495 12.1898 15.0571 12.125 15.0482C11.9918 15.0299 11.7449 14.9841 11.5171 14.8768C11.4297 14.8356 11.3412 14.7897 11.2536 14.7412C10.5161 14.3327 9.88311 13.7833 9.32946 13.1629C9.18565 13.0017 9.04854 12.8354 8.9403 12.68C8.53778 12.1021 8.27226 11.7795 8.10352 11.0559L8.1019 11.049C8.03393 10.7576 8.01892 10.6932 7.97223 10.4697C7.92904 10.1987 8.20611 10.1125 8.30377 10.2139C8.42709 10.3419 8.52849 10.4465 8.57242 10.4902C9.68242 11.5952 10.1978 12.3204 11.3133 13.4198C11.6955 13.7964 11.9032 14.004 12.2229 14.4304Z",
    fill: "url(#paint3_linear_1846_32440)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6103 15.8913C11.7549 15.9589 11.8676 16.019 11.9821 16.08C12.0733 16.1285 12.0752 16.2871 11.9863 16.3709C11.9337 16.4204 11.876 16.4598 11.8147 16.4825C11.6886 16.529 11.4492 16.6048 11.1976 16.6173C11.1012 16.6221 11.0015 16.6233 10.9013 16.6217C10.0583 16.6083 9.24128 16.4215 8.46079 16.1346C8.25806 16.0601 8.05883 15.9779 7.89018 15.8918C7.26304 15.5713 6.87695 15.4116 6.38752 14.8526L6.38284 14.8472C6.1857 14.6221 6.14215 14.5723 5.99578 14.3971C5.83016 14.1784 6.03403 13.9719 6.16791 14.0153C6.33696 14.0703 6.47565 14.1148 6.535 14.1327C8.03442 14.5853 8.83046 14.9826 10.3321 15.4276C10.8466 15.5801 11.1275 15.6655 11.6103 15.8913Z",
    fill: "url(#paint4_linear_1846_32440)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0895 17.5602C11.2095 17.5792 11.3046 17.5996 11.4013 17.6201C11.4782 17.6365 11.5132 17.7533 11.4659 17.8342C11.4379 17.8821 11.4041 17.9236 11.364 17.9535C11.2817 18.0149 11.1227 18.1221 10.9414 18.1852C10.872 18.2094 10.7993 18.2316 10.7257 18.2519C10.1066 18.4225 9.46971 18.4594 8.83838 18.4144C8.67439 18.4028 8.51134 18.3847 8.3698 18.3571C7.84346 18.2545 7.5274 18.2191 7.05125 17.9107L7.0467 17.9077C6.85491 17.7835 6.81254 17.7561 6.66844 17.6579C6.50105 17.5317 6.60639 17.3354 6.71347 17.3389C6.8487 17.3433 6.95952 17.3465 7.00671 17.347C8.19872 17.3605 8.86481 17.4838 10.0569 17.4912C10.4653 17.4937 10.6887 17.4967 11.0895 17.5602Z",
    fill: "url(#paint5_linear_1846_32440)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5916 19.2275C11.7016 19.2083 11.7901 19.1969 11.88 19.1853C11.9515 19.1761 12.0094 19.2521 11.9866 19.3246C11.9731 19.3675 11.9529 19.4073 11.9246 19.4403C11.8664 19.5081 11.7513 19.6308 11.6064 19.7272C11.5508 19.7642 11.492 19.8006 11.4319 19.8358C10.9264 20.1321 10.3742 20.3352 9.80793 20.4766C9.66083 20.5134 9.51307 20.5452 9.38204 20.564C8.89479 20.6342 8.6083 20.6956 8.11745 20.6008L8.11276 20.5999C7.91505 20.5617 7.87137 20.5532 7.72169 20.521C7.54501 20.4746 7.59217 20.3014 7.68726 20.2744C7.80734 20.2402 7.90567 20.212 7.94733 20.1993C8.99998 19.8798 9.61508 19.7862 10.6664 19.4622C11.0265 19.3512 11.224 19.2917 11.5916 19.2275Z",
    fill: "url(#paint6_linear_1846_32440)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8447 20.266C12.9068 20.2111 12.9587 20.1697 13.0113 20.1277C13.0532 20.0943 13.1274 20.125 13.1474 20.1838C13.1592 20.2186 13.1653 20.2537 13.1628 20.2873C13.1576 20.3562 13.1419 20.4846 13.0943 20.6061C13.0761 20.6527 13.0554 20.7001 13.0334 20.7471C12.8481 21.1432 12.5878 21.4925 12.2887 21.8045C12.211 21.8855 12.1305 21.9633 12.0546 22.0259C11.7725 22.2586 11.6163 22.4094 11.2526 22.5294L11.2491 22.5305C11.1026 22.5789 11.0702 22.5895 10.9577 22.6238C10.8209 22.6585 10.7683 22.5209 10.8169 22.4662C10.8783 22.3972 10.9285 22.3405 10.9494 22.316C11.4782 21.697 11.832 21.3997 12.3577 20.7781C12.5379 20.5651 12.6372 20.4493 12.8447 20.266Z",
    fill: "url(#paint7_linear_1846_32440)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2666 15.8089C15.2831 15.7525 15.363 15.7525 15.3795 15.8089L15.5118 16.2618C15.6415 16.7057 15.9346 17.0839 16.3321 17.3203C16.3552 17.3341 16.3552 17.3676 16.3321 17.3814C15.9346 17.6178 15.6415 17.996 15.5118 18.4399L15.3795 18.8928C15.363 18.9492 15.2831 18.9492 15.2666 18.8928L15.1343 18.4399C15.0046 17.996 14.7115 17.6178 14.314 17.3814C14.2909 17.3676 14.2909 17.3341 14.314 17.3203C14.7115 17.0839 15.0046 16.7057 15.1343 16.2618L15.2666 15.8089Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2388 17.3507C18.6005 17.3507 15.7569 9.92822 23.5167 9.92822M11.9492 25.1106C17.6366 20.7728 12.2384 17.3507 14.4073 17.3507",
    stroke: "white",
    strokeWidth: 0.177778
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0048 24.1998C42.6976 24.1998 42.4289 24.1821 42.1985 24.1467C41.9631 24.1163 41.7634 24.0784 41.5996 24.0329V22.0755C41.7634 22.1109 41.94 22.1437 42.1294 22.1741C42.3137 22.2095 42.5108 22.2272 42.7207 22.2272C42.9971 22.2272 43.2454 22.1741 43.4655 22.0679C43.6856 21.9667 43.8596 21.772 43.9876 21.4837C44.1156 21.1954 44.1796 20.7806 44.1796 20.2394V9.84533H46.5599V20.2243C46.5599 21.1751 46.4089 21.9414 46.1069 22.5231C45.81 23.1098 45.3928 23.5347 44.8553 23.7977C44.3229 24.0658 43.7061 24.1998 43.0048 24.1998Z",
    fill: "#1B1B1B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7001 20.9374V9.84533H52.0804V20.9374H49.7001Z",
    fill: "#1B1B1B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0278 9.84533L60.2116 20.9374H57.6163L53.8077 9.84533H56.2111L58.3227 16.446C58.3585 16.5572 58.4174 16.7671 58.4993 17.0757C58.5812 17.3792 58.6631 17.7029 58.745 18.0468C58.832 18.3857 58.8909 18.6664 58.9216 18.889C58.9523 18.6664 59.0061 18.3857 59.0828 18.0468C59.1647 17.7079 59.2441 17.3867 59.3209 17.0833C59.4028 16.7747 59.4616 16.5623 59.4975 16.446L61.6244 9.84533H64.0278Z",
    fill: "#1B1B1B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.635 20.9374L71.8211 18.2972H67.7285L66.9146 20.9374H64.35L68.312 9.7998H71.2222L75.1996 20.9374H72.635ZM71.2529 16.3246L70.439 13.745C70.3878 13.573 70.3187 13.353 70.2316 13.0849C70.1497 12.8118 70.0653 12.5362 69.9783 12.258C69.8964 11.9747 69.8298 11.7294 69.7786 11.522C69.7274 11.7294 69.6558 11.9874 69.5636 12.2959C69.4766 12.5994 69.3921 12.8877 69.3102 13.1608C69.2283 13.4339 69.1695 13.6287 69.1336 13.745L68.3274 16.3246H71.2529Z",
    fill: "#1B1B1B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1846_32440",
    x1: 11.867,
    y1: 12.6256,
    x2: 21.6686,
    y2: 39.4225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1846_32440",
    x1: 15.3343,
    y1: 4.29986,
    x2: 31.8138,
    y2: 29.9963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1846_32440",
    x1: 11.0345,
    y1: 6.3344,
    x2: 29.9739,
    y2: 23.7948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1846_32440",
    x1: 7.82947,
    y1: 10.4488,
    x2: 26.8109,
    y2: 18.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1846_32440",
    x1: 5.86,
    y1: 14.4459,
    x2: 26.5956,
    y2: 12.9889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1846_32440",
    x1: 6.5795,
    y1: 17.723,
    x2: 21.4699,
    y2: 12.3139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1846_32440",
    x1: 7.65851,
    y1: 20.5934,
    x2: 18.4023,
    y2: 11.2332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1846_32440",
    x1: 10.9515,
    y1: 22.6978,
    x2: 14.4788,
    y2: 12.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FD3F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandLogo);
export default __webpack_public_path__ + "static/media/brand-logo.0f187ebc70fc5c5867a1dc16dbb6fa81.svg";
export { ForwardRef as ReactComponent };